var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWideLineBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 327,
    viewBox: "0 0 1920 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M-0.5 191.5C228.5 238 499 -60.0525 672.5 12.0002C914.5 112.5 1354 396.5 1920 309.5",
    stroke: "#BFB098"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWideLineBottom);
export default __webpack_public_path__ + "static/media/wide-line-bottom.8ea6d081a2c1056a87abab5eb1b3037a.svg";
export { ForwardRef as ReactComponent };